import React from "react";
import "./SummaryTile.css";

export default function SummaryTile({
  race,
  raceDate,
  intensity,
  trainingWeeks = null,
  totalPlanMileage = null,
  unitPreference = "Miles",
}) {
  const unitSuffix = unitPreference === "Kilometers" ? "km" : "mi";
  const daysUntilRace = daysUntilRaceFromToday(raceDate);
  const weeksLabel =
    typeof trainingWeeks === "number" && trainingWeeks > 0
      ? String(trainingWeeks)
      : "—";
  const daysUntilLabel =
    daysUntilRace != null ? String(daysUntilRace) : "—";
  const totalMileageLabel =
    typeof totalPlanMileage === "number" && totalPlanMileage > 0
      ? `${totalPlanMileage} ${unitSuffix}`
      : "—";

  return (
    <div className="pw-summary-tile" data-pw-plan-section="summary">
      <h2 className="pw-summary-title">Your Training Plan</h2>

      <div className="pw-summary-meta-grid">
        <div className="pw-summary-meta-item">
          <span className="pw-summary-meta-label">Race</span>
          <span className="pw-summary-meta-value">{race || "—"}</span>
        </div>
        <div className="pw-summary-meta-item">
          <span className="pw-summary-meta-label">Date</span>
          <span className="pw-summary-meta-value">
            {formatDate(raceDate)}
          </span>
        </div>
        <div className="pw-summary-meta-item">
          <span className="pw-summary-meta-label">Intensity</span>
          <span className="pw-summary-meta-value">
            {intensity || "—"}
          </span>
        </div>
        <div className="pw-summary-meta-item">
          <span className="pw-summary-meta-label">Total Weeks</span>
          <span className="pw-summary-meta-value">{weeksLabel}</span>
        </div>
        <div className="pw-summary-meta-item">
          <span className="pw-summary-meta-label">Days Until Race</span>
          <span className="pw-summary-meta-value">{daysUntilLabel}</span>
        </div>
        <div className="pw-summary-meta-item">
          <span className="pw-summary-meta-label">Total Plan Mileage</span>
          <span className="pw-summary-meta-value">{totalMileageLabel}</span>
        </div>
      </div>
    </div>
  );
}

function parseLocalDate(str) {
  if (!str || typeof str !== "string") return new Date(str);
  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return new Date(str);
  const [, y, mo, d] = m.map(Number);
  return new Date(y, mo - 1, d);
}

function formatDate(d) {
  if (!d) return "—";
  const dt = parseLocalDate(d);
  if (isNaN(dt.getTime())) return String(d || "—");
  return dt.toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

/** Calendar days from local today (midnight) to race date; 0 if today or past. */
function daysUntilRaceFromToday(raceDateInput) {
  if (raceDateInput == null || raceDateInput === "") return null;
  const race = parseLocalDate(raceDateInput);
  if (isNaN(race.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const raceDay = new Date(
    race.getFullYear(),
    race.getMonth(),
    race.getDate()
  );
  const diffDays = Math.round((raceDay - today) / 86400000);
  return Math.max(0, diffDays);
}
